import { Box, styled } from "@mui/material";
import { Button, Typography } from "@pmag/ui-components";

export const Root = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8),
    },
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(6),
    borderBottom: `1px solid ${theme.palette.core.grey._20}`,

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(8),
        borderBottom: "unset",
    },
}));

export const TopRightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(6),

    [theme.breakpoints.down("sm")]: {
        flex: 1,
        justifyContent: "space-between",
    },
}));

export const NavigationButton = styled(Button)(() => ({
    display: "flex",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
}));

export const ListContainer = styled(Box)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.core.grey._30}`,
}));

export const EmptyListContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(8),
}));

export const CenteredTypography = styled(Typography)(() => ({
    textAlign: "center",
}));

export const BottomContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),

    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "flex-start",
    },
}));

export const BottomRightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),

    [theme.breakpoints.down("sm")]: {
        width: "100%",
        justifyContent: "space-between",
    },
}));

export const RemoveButton = styled(Button)(() => ({
    paddingLeft: 0,
}));
